import { getMessage } from "common/messageUtil"
import { magiContants } from "utils/contants"

const initUpdateFormValues = {
  selectionFileName: '',
  targetYear: '',
  selectionFileManagementId: 0,
  sysVersionNumber:0,
  companyId: 0
}

const deleteRequest = {
  companyId: 0,
  selectionFileManagementId: 0,
  sysVersionNumber: 0,
}

const textMap = {
  update: {
    submit: 'OK',
    cancel: 'キャンセル',
    message: getMessage(magiContants.MESSAGECODE_MCBOS030_005),
  },
  cancel: {
    submit: 'OK',
    cancel: 'キャンセル',
    message: getMessage(magiContants.MESSAGECODE_MCBOS030_010),
  },
  delete: {
    submit: 'OK',
    cancel: 'キャンセル',
    message: getMessage(magiContants.MESSAGECODE_MCBOS030_008),
  },
  confirmChange: {
    submit: 'OK',
    cancel: 'キャンセル',
    message: getMessage(magiContants.MESSAGECODE_MCBOS030_006)
  },
}

export {
  textMap,
  deleteRequest, 
  initUpdateFormValues,
}
